import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { Notifications } from 'pages/Notifications';
import { Applications } from 'pages/Applications';
import { Application } from 'pages/Application';

export const RoutesWithAccess = () => {
  return (
    <Switch>
      <Route path="/umsoknir/" exact children={<Applications />} />
      <Route path="/umsoknir/umsokn/:applicationID" exact children={<Application />} />
      <Route path="/" children={<Notifications />} />
    </Switch>
  );
};
